import { Select, SelectProps } from "antd";
import { useEffect, useMemo } from "react";
import { CANADA_PROVINCES, CountryCode, US_STATES } from "../api/models";
import Utils from "../util/util";


const StatesSelector = ( props: Omit<SelectProps, 'value' | 'onChange'> & {
    value?: string;
    onChange?: (state?: string ) => void;
    country?: string
    includeTbd?: boolean
    includeCanada?: boolean
  }) => {

  const {country:a, includeTbd:b, ...selectProps} = props;

  useEffect(() => {
    if (props.country && props.value)  {
      const states = Utils.getStates(props.country).map(s => s.value );
      const selected = states.includes(props.value);
      if ( !selected ) {
        props.onChange?.(undefined);
      }
    }
  }, [props.country]);

  const options = useMemo(() => {

    const tbd =  {
      value: "TBD",
      label: "TBD"
    };

    const CA =  {
      value: "CAN",
      label: "Canada"
    };

    const states = Utils.getStates(props.country).map(state => ({
        value:state.value,
        label:state.name
      })) ;

    if ( props.includeCanada ?? true ) {
      states.push(CA);
    }

    return props.includeTbd 
      ? [tbd, ...states]
      : states;

  }, [props.country, props.includeTbd] );

  return (
    <Select
      showSearch={true}
      allowClear={true}
      {...selectProps}
      style={{minWidth: "11rem", ...props.style}}
      optionFilterProp="value"
      options={options}
      />
  );
}

export default StatesSelector;

